"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createDirectLine: true,
  renderWebChat: true,
  createCognitiveServicesBingSpeechPonyfillFactory: true,
  createCognitiveServicesSpeechServicesPonyfillFactory: true,
  createStyleSet: true,
  renderMarkdown: true
};
Object.defineProperty(exports, "createCognitiveServicesBingSpeechPonyfillFactory", {
  enumerable: true,
  get: function get() {
    return _createCognitiveServicesBingSpeechPonyfillFactory.default;
  }
});
Object.defineProperty(exports, "createCognitiveServicesSpeechServicesPonyfillFactory", {
  enumerable: true,
  get: function get() {
    return _createCognitiveServicesSpeechServicesPonyfillFactory.default;
  }
});
Object.defineProperty(exports, "createStyleSet", {
  enumerable: true,
  get: function get() {
    return _createStyleSetWithAdaptiveCards.default;
  }
});
Object.defineProperty(exports, "renderMarkdown", {
  enumerable: true,
  get: function get() {
    return _renderMarkdown.default;
  }
});
exports.renderWebChat = exports.default = exports.createDirectLine = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _indexMinimal = require("./index-minimal");

Object.keys(_indexMinimal).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _indexMinimal[key];
    }
  });
});

var _addVersion = _interopRequireDefault(require("./addVersion"));

var _renderWebChat = _interopRequireDefault(require("./renderWebChat"));

var _createCognitiveServicesBingSpeechPonyfillFactory = _interopRequireDefault(require("./createCognitiveServicesBingSpeechPonyfillFactory"));

var _createCognitiveServicesSpeechServicesPonyfillFactory = _interopRequireDefault(require("./createCognitiveServicesSpeechServicesPonyfillFactory"));

var _createStyleSetWithAdaptiveCards = _interopRequireDefault(require("./adaptiveCards/Styles/createStyleSetWithAdaptiveCards"));

var _createDirectLine = _interopRequireDefault(require("./createDirectLine"));

var _FullReactWebChat = _interopRequireDefault(require("./FullReactWebChat"));

var _renderMarkdown = _interopRequireDefault(require("./renderMarkdown"));
/* eslint dot-notation: ["error", { "allowPattern": "^WebChat$" }] */
// window['WebChat'] is required for TypeScript


var renderWebChat = _renderWebChat.default.bind(null, _FullReactWebChat.default);

exports.renderWebChat = renderWebChat;

var createDirectLine = function createDirectLine(options) {
  options.botAgent && console.warn('Web Chat: Developers are not currently allowed to set botAgent. See https://github.com/microsoft/BotFramework-WebChat/issues/2119 for more details.');
  return (0, _createDirectLine.default)((0, _objectSpread2.default)({}, options, {
    botAgent: "WebChat/".concat(_indexMinimal.version, " (Full)")
  }));
};

exports.createDirectLine = createDirectLine;
var _default = _FullReactWebChat.default;
exports.default = _default;
window['WebChat'] = (0, _objectSpread2.default)({}, window['WebChat'], {
  createCognitiveServicesBingSpeechPonyfillFactory: _createCognitiveServicesBingSpeechPonyfillFactory.default,
  createCognitiveServicesSpeechServicesPonyfillFactory: _createCognitiveServicesSpeechServicesPonyfillFactory.default,
  createDirectLine: createDirectLine,
  createStyleSet: _createStyleSetWithAdaptiveCards.default,
  ReactWebChat: _FullReactWebChat.default,
  renderMarkdown: _renderMarkdown.default,
  renderWebChat: renderWebChat
});
(0, _addVersion.default)('full');